import React from "react";

import { cn } from "~/lib/utils";

interface RadioCardProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
    description?: string;
    value: string;
    name: string;
    checked?: boolean;
    labelClassName?: string;
}

export const RadioCard: React.FC<RadioCardProps> = ({
    label,
    description,
    value,
    name,
    checked,
    onChange,
    labelClassName,
    ...props
}) => {
    const id = `${name}_${value}`;

    return (
        <div className="relative">
            <input
                id={id}
                type="radio"
                name={name}
                value={value}
                checked={checked}
                onChange={onChange}
                className="peer hidden"
                {...props}
            />
            <span className="pointer-events-none absolute right-4 top-1/2 box-content block size-3 -translate-y-1/2 rounded-full border-8 border-gray-300 bg-white peer-checked:border-brand-terra-500"></span>
            <label
                htmlFor={id}
                className="flex cursor-pointer flex-col rounded-lg border border-gray-300 p-4 hover:bg-gray-50 peer-checked:border-2 peer-checked:border-brand-forest-700 peer-disabled:cursor-not-allowed peer-disabled:border-gray-200 peer-disabled:bg-gray-50 peer-disabled:opacity-60 peer-disabled:hover:bg-gray-50"
            >
                <span
                    className={cn(
                        "text-lg font-medium text-brand-forest-800",
                        labelClassName,
                    )}
                >
                    {label}
                </span>
                {description && (
                    <span className="mt-1 text-sm text-gray-500">
                        {description}
                    </span>
                )}
            </label>
        </div>
    );
};
